<script>
  import EstadoLoteService from '../../../../domain/estado-lote/services/estado-lote'

  export default {
    name: 'SelectEstadoGeral',
    props: {
      value: {
        required: true
      }
    },
    data () {
      return {
        data: []
      }
    },
    computed: {
      model: {
        get () {
          return this.value === null ? '' : this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    created () {
      this.load()
    },
    methods: {
      load () {
        EstadoLoteService.listAll()
          .then(response => {
            this.data = response.data
          })
          .catch(error => {
            window.responseError(error)
          })
      }
    }
  }
</script>

<template>
  <div class="form-group">
    <label class="col-lg-2 control-label">Estado Geral</label>
    <div class="col-lg-10">
      <select class="form-control w-auto w-full-xs" v-model="model" required>
        <option :value="item.id" v-for="item in data" :key="item.id">{{item.descricao}}</option>
      </select>
    </div>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectEstadoGeral.vue?5248d674